import React from "react";
import { Skeleton } from "antd";
import { Route, Switch } from "react-router-dom";

import CashInflows from "./components/CashInflows/CashInflows";
import CashOutflows from "./components/CashOutflows/CashOutflows";
import Summary from "./components/Summary/Summary";

import {
  buildPCFSummaryUri,
  buildPCFInflowsUri,
  buildPCFOutflowsUri,
} from "utils/routes";

import { useFetchConstant } from "apis/constant";

const CashFlow = ({ isLoading, cashFlowDetails }) => {
  const cashInflowSummary = {
    isOverridden: cashFlowDetails.isInflowTotalOverridden,
    totalValue: cashFlowDetails.totalInflow || 0,
  };

  const cashOutflowSummary = {
    isOverridden: cashFlowDetails.isOutflowTotalOverridden,
    totalExpensesValue:
      cashFlowDetails.totalMonthlyExpensesExcludingMonthlyPremium || 0,
    totalLoanInstalmentsValue: cashFlowDetails.totalLoanInstalment || 0,
    monthlyPremium: cashFlowDetails.monthlyPremium || 0,
  };

  const {
    isLoading: isIncomeTemplateLoading,
    selection: incomeTemplate,
  } = useFetchConstant("cashflowInflowTemplate");

  const {
    isLoading: isExpensesTemplateLoading,
    selection: expensesTemplate,
  } = useFetchConstant("cashflowExpensesTemplate");

  return (
    <Switch>
      <Route path={buildPCFSummaryUri()}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Summary summaryInfo={cashFlowDetails} />
        )}
      </Route>
      <Route path={buildPCFInflowsUri()}>
        <CashInflows
          sources={cashFlowDetails.inflowSources}
          cashInflowSummary={cashInflowSummary}
          incomeTemplate={incomeTemplate}
        />
      </Route>
      <Route path={buildPCFOutflowsUri()}>
        <CashOutflows
          expenses={cashFlowDetails.outflowPayments}
          cashOutflowSummary={cashOutflowSummary}
          expensesTemplate={expensesTemplate}
        />
      </Route>
    </Switch>
  );
};

export default CashFlow;
